import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from '@mui/icons-material';
import NewCopyIcon from '@src/assets/icons/new-copy-icon.svg';
import { CRM_URL } from '@src/configs';
import MobileWeb from '@src/assets/images/mobile-desktop.svg';
import sanitize from 'sanitize-html';
import routes from '@src/constants/route';
import Typography from '@src/new-components/Typography';
import QRCode from '@src/assets/images/qr-mobile-app.png';
import AppStore from '@src/assets/images/apple-store-vi.svg';
import CHPlay from '@src/assets/images/google-store-vi.svg';
import {
  AIVOICE_TTS_APP_STORE_URL,
  AIVOICE_TTS_GOOGLE_PLAY_URL,
} from '@src/constants/mobileApp';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import { VoiceLibraryMobileContainer } from './index.style';

const VoiceLibraryMobile = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleClickCopy = () => {
    navigator.clipboard.writeText(`${CRM_URL}${routes.VOICE_LIBRARY}`);
    setCopied(true);
  };

  const handleClickDownload = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <VoiceLibraryMobileContainer>
      <div style={{ textAlign: 'center' }}>
        <img
          className="icon-mobile-web"
          src={MobileWeb}
          alt="icon-mobile-web"
        />
      </div>
      <div className="content-wrapper">
        <Typography
          variant="body-14-regular"
          color={COLOR.darkGray}
          className="noti-mobile"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitize(t('notiMobileVoiceLibrary')),
          }}
        />
        <CommonButton onClick={handleClickCopy} className="button-copy-url">
          {!copied ? (
            <img src={NewCopyIcon} alt="copy-icon" className="copy-icon" />
          ) : (
            <Check className="checked-icon" />
          )}
          <Typography variant="body-16-bold">
            {!copied ? t('copyLink') : t('copiedv2')}
          </Typography>
        </CommonButton>
      </div>
      <div className="download-app-wrapper">
        <Typography variant="body-12-regular">
          {t('downloadAppContent')}
        </Typography>
        <div className="download-app">
          <img src={QRCode} alt="vbee-qr-code" className="qr-code" />
          <div className="download-button-container">
            <CommonButton
              onClick={() => handleClickDownload(AIVOICE_TTS_APP_STORE_URL)}
              className="download-button"
            >
              <img src={AppStore} alt="App Store" />
            </CommonButton>
            <CommonButton
              onClick={() => handleClickDownload(AIVOICE_TTS_GOOGLE_PLAY_URL)}
              className="download-button"
            >
              <img src={CHPlay} alt="CH Play" />
            </CommonButton>
          </div>
        </div>
      </div>
    </VoiceLibraryMobileContainer>
  );
};

export default VoiceLibraryMobile;
